import React from 'react'
import { FormattedMessage } from 'react-intl'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./CheckableGroup.css'))

interface Props {
  label: string
}

const CheckableGroup: React.FC<Props> = ({ label, children }) => {
  return (
    <div className={bem.b('CheckableGroup').show()}>
      <div
        className={bem
          .b('CheckableGroup')
          .e('label')
          .show()}
      >
        <FormattedMessage id={label} />
      </div>
      <div
        className={bem
          .b('CheckableGroup')
          .e('content')
          .show()}
      >
        {children}
      </div>
    </div>
  )
}

export default CheckableGroup
